__turbopack_context__.v({
  "input": "multi-select-module__2VCF5a__input",
});
